import qs from "qs"

export const qsParse = function (str, options) {
    return qs.parse(str, {
        ignoreQueryPrefix: true,
        ...options
    })
}

export const qsStringify = function (obj, options) {
    return qs.stringify(obj, {
        arrayFormat: 'repeat',
        ...options
    })
}